module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', [_c('app-nav')], 1), _vm._v(" "), _c('section', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), (!_vm.horaInicio) ? _c('p', [_vm._v("A prova ainda não iniciou...")]) : _vm._e(), _vm._v(" "), (_vm.horaInicio) ? _c('h1', {
    staticClass: "text-center tempo"
  }, [_vm._v(_vm._s(_vm.tempoProva))]) : _vm._e(), _vm._v(" "), _c('br')])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h2', [_vm._v("Tempo de Prova")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7da5a8f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pub/Tempo.vue
// module id = 265
// module chunks = 1